<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-card>
          <el-button type="primary" plain icon="el-icon-plus" style="margin-bottom: 20px;">启动发布</el-button>

          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">2026～2027</span>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="6" v-for="(item, i) in list" :key="i">
              <div class="camp-item" @click="goCampDetail(item.id)">
                <img class="bg" :src="item.coverUrl" alt="">
                <div class="panel">
                  <div class="name">{{ item.productName }}</div>
                  <div class="enName">{{ item.enName }}</div>
                  <div class="flex">
                    <div>{{ item.place }}</div>
                    <div>{{ item.duration }}</div>
                  </div>
                  <div class="price">{{ item.price }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <template v-if="expand">
            <el-row class="title_row">
              <el-col :span="12">
                <span class="title_class">2025～2026</span>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6" v-for="(item, i) in list" :key="i">
                <div class="camp-item" @click="goCampDetail(item.id)">
                <img class="bg" :src="item.coverUrl" alt="">
                <div class="panel">
                  <div class="name">{{ item.productName }}</div>
                  <div class="enName">{{ item.enName }}</div>
                  <div class="flex">
                    <div>{{ item.place }}</div>
                    <div>{{ item.duration }}</div>
                  </div>
                  <div class="price">{{ item.price }}</div>
                </div>
              </div>
              </el-col>
            </el-row>
          </template>
          <div class="bottom-btn" v-if="!expand" @click="expand = true">查看历史赛季信息 <i class="el-icon-caret-bottom"></i></div>
          <div class="bottom-btn" v-if="expand" @click="expand = false">折叠历史赛季信息 <i class="el-icon-caret-top"></i></div>
        </el-card>
      </el-col>
    </el-row>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">审核进度</span>
        </el-col>
      </el-row>
      <el-table :data="auditList" style="margin-top: 15px">
        <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
        <el-table-column prop="price" label="产品价格" align="center"></el-table-column>
        <el-table-column label="审批等级" align="center">一级部门</el-table-column>
        <el-table-column label="审批意见" align="center">同意</el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="center"></el-table-column>
        <el-table-column prop="createTime" label="更新日期" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审批状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auditStatus === 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 1" type="success" size="small">通过</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 2" type="danger" size="small">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template>
            <el-button type="text" size="mini">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'Components',
  data () {
    return {
      expand: false,
      list: [
        {
          // id: 10,
          id: 15,
          productName: '华北站',
          description: '',
          price: '¥7800',
          place: '北京',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/camp/bg_huabei.png'
        },
        {
          // id: 11,
          id: 16,
          productName: '华东站',
          description: '',
          price: '¥7800',
          place: '上海',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/camp/bg_huadong.png'
        },
        {
          // id: 12,
          id: 17,
          productName: '华南站',
          description: '',
          price: '¥7800',
          place: '深圳',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/camp/bg_huanan.png'
        }
      ],
      list2: [],
      auditList: [
        { productName: '2026北京夏令营', price: '¥5800', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }
      ]
    }
  },
  methods: {
    goCampDetail (id) {
      this.$router.push(
        {
          path: '/raceManagement/camp/campDetailsData',
          query: {
            campId: id
          }
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.4);
    }
    .bg{
      width: 100%;
      height: 160px;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 2px 12px 10px;
      .name{
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .enName{
        color: #000;
        font-size: 11px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #f00;
        margin-top: 10px;
      }
      .date{
        color: #969696;
        font-size: 12px;
        margin-top: 8px;
        text-align: right;
      }
    }
  }
  .paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
.bottom-btn{
  width: 200px;
  margin: 40px auto 0;
  font-size: 14px;
  color: #4096ff;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  i{
    font-size: 20px;
  }
  &:hover{
    text-decoration: underline;
  }
}
</style>
